export default __webpack_public_path__ + "static/media/bacqueville5.160a228c.jpg";